<template src="./AppSlider.html"></template>

<script>
export default {
  name: "app-slider",

  data() {
    return {
      isOpen: true,
    };
  },

  methods: {
    toggleSlider() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>
